import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PalletisingConfigurationService } from '../services/palletising.configuration.service';
import { IFormLayerParam, ILayerParam } from '../types';

@Component({
	selector: 'app-create-update-layer-param',
	templateUrl: './create-update-layer-param.html',
	styleUrls: ['./create-update-layer-param.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateUpdateLayerParamDialogComponent implements OnInit {
	@Output() saved = new EventEmitter<void>();
	public form: FormGroup;
	public isCreatingLayerParam: boolean;
	public layerParam: ILayerParam;
	public headingKey: string;
	public constructor(
		@Inject(MAT_DIALOG_DATA) public data: ILayerParam | null,
		public dialogRef: MatDialogRef<CreateUpdateLayerParamDialogComponent>,
		private service: PalletisingConfigurationService,
		private fb: FormBuilder,
	) {
		this.layerParam = data || this.defaultLayerParam;
		this.isCreatingLayerParam = data === null;
	}

	public ngOnInit(): void {
		this.initializeForm();
	}

	private initializeForm(): void {
		this.headingKey = this.isCreatingLayerParam ? 'masterdata.palletising.configuration.layers.createLabel' : 'masterdata.palletising.configuration.layers.updateLabel';
		this.form = this.fb.group({
			layer: [this.layerParam.layer, [Validators.required, Validators.min(1), Validators.max(10000)]],
			maxHeightAfter: [this.layerParam.maxHeightAfter, [Validators.required, Validators.min(1), Validators.max(10000)]],
			maxWeightElement: [this.layerParam.maxWeightElement, [Validators.required, Validators.min(1), Validators.max(10000)]],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value: IFormLayerParam) => {
			this.layerParam.layer = Number(value.layer);
			this.layerParam.maxHeightAfter = Number(value.maxHeightAfter);
			this.layerParam.maxWeightElement = Number(value.maxWeightElement);
		});
	}

	public onCancel(): void {
		this.dialogRef.close();
	}

	public onCreateUpdateSave(): void {
		if (this.isCreatingLayerParam) {
			this.service.onCreateUpdateLayerSave(this.layerParam);
		}
		this.dialogRef.close();
		this.service.updateConfiguration();
	}

	public get controls() {
		return this.form.controls;
	}

	private get defaultLayerParam(): ILayerParam {
		return {
			layer: 1,
			maxHeightAfter: 10_000,
			maxWeightElement: 10_000,
			type: {
				self: '/palletising/configuration-stacking-rule-types/layer',
			},
		};
	}
}
